module.exports = __webpack_public_path__ + "static/media/report-aura-background-compare-v2.119502f8.svg";